// Copyright © 2021 Move Closer
import { RelatedType } from '../contracts';
import { SetDriver } from './set';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class DeduplicatedSetDriver extends SetDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.DeduplicatedSet;
    }
}
